import {satGlobals} from "../../../../../sat/helper/sat-globals";
import axios from 'axios';

class Analytics {

    listener = false;

    constructor() {
    }

    async send(metric, action, job = {apiJob: {id: 'no_id'}}) {

        if (job.apiJob === null) {
            job = {apiJob: {id: 'no_id'}};
        }

        await axios.post(satGlobals.getApiUrl('api/z'), {
            data: {
                message: metric,
                job_id: job.apiJob.id,
                action: action
            }
        }, {withCredentials: true});
    }

    async sendWithData(metric, action, job = {apiJob: {id: 'no_id'}}, payload = {}) {

        let data = {
            ...payload, ...{
                message: metric,
                job_id: job.apiJob.id,
                action: action
            }
        };

        await axios.post(satGlobals.getApiUrl('api/z'), {
            data: data
        }, {withCredentials: true});
    }
}

export default new Analytics()